<frontend-header>
  <button
    *ngIf="!!showingWorkflowsOfType"
    mat-icon-button
    disableRipple
    (click)="reset()"
  >
    <mat-icon class="arrow-back">arrow_back</mat-icon>
  </button>
</frontend-header>

<frontend-workflow-selector
  *ngIf="showingWorkflowsOfType === workflowType.In"
  [workflows]="(state$ | async).checkInWorkflows"
  [type]="workflowType.In"
>
</frontend-workflow-selector>

<frontend-workflow-selector
  *ngIf="showingWorkflowsOfType === workflowType.Out"
  [workflows]="(state$ | async).checkOutWorkflows"
  [type]="workflowType.Out"
>
</frontend-workflow-selector>

<div class="mat-typography" *ngIf="!showingWorkflowsOfType">
  <mat-icon svgIcon="hand" class="hand"></mat-icon>
  <h2 i18n="@@welcomeShort">Welcome!</h2>
  <h3 *ngIf="(state$ | async).welcomeMessage">{{ (state$ | async).welcomeMessage }}</h3>
  <h3 *ngIf="!(state$ | async).welcomeMessage" i18n="@@welcomeLong">
    We're glad you are here.
  </h3>

  <button
    *ngIf="(state$ | async).showCheckinBtn"
    mat-raised-button
    (click)="showIn()"
    i18n="@@checkingInBtn"
  >
    I'M CHECKING IN
  </button>
  <button
    *ngIf="(state$ | async).implicitInId as implicitInId"
    mat-raised-button
    routerLink="/check-in"
    queryParamsHandling="preserve"
    i18n="@@checkingInBtn"
    (click)="setWorkflowId(implicitInId)"
  >
    I'M CHECKING IN
  </button>

  <button
    *ngIf="(state$ | async).showCheckoutBtn"
    mat-raised-button
    (click)="showOut()"
    i18n="@@checkingOutBtn"
  >
    I'M CHECKING OUT
  </button>
  <button
    *ngIf="(state$ | async).implicitOutId as implicitOutId"
    mat-raised-button
    routerLink="/check-out"
    queryParamsHandling="preserve"
    i18n="@@checkingOutBtn"
    (click)="setWorkflowId(implicitOutId)"
  >
    I'M CHECKING OUT
  </button>
</div>
